import { useMemo } from 'react'
import PropTypes from 'prop-types'
import Chart from 'react-apexcharts'
import dayjs from '../../lib/datetime'
import { formatCycleRange } from '../../lib/cycles'

export default function ConnectivityRatesChart({ rates }) {
  const chartOptions = useMemo(() => ({
    chart: {
      type: 'area',
      toolbar: { show: false },
      zoom: { enabled: false },
      fontFamily: 'inherit',
    },
    dataLabels: { enabled: false },
    stroke: {
      curve: 'straight',
      width: 2.5,
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0.05,
        stops: [0, 95, 100],
      },
    },
    grid: {
      borderColor: '#f1f5f9',
      strokeDashArray: 4,
      xaxis: { lines: { show: false } },
    },
    markers: {
      size: 4,
      strokeWidth: 2,
      strokeColors: '#fff',
      hover: { size: 6 },
    },
    xaxis: {
      categories: rates.map(rate => dayjs(rate.cycle.endsAt).format('MMM YY')),
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: {
        rotate: -45,
        rotateAlways: true,
        style: { colors: '#94a3b8', fontSize: '11px' },
      },
    },
    yaxis: {
      labels: {
        formatter: value => `${Math.round(value)}%`,
        style: { colors: '#94a3b8', fontSize: '11px' },
      },
      min: 0,
      max: Math.min(100, Math.ceil(rates.reduce((max, r) => Math.max(max, r.conectivityRate * 100), 0) / 10) * 10 + 10),
    },
    colors: ['#22c55e'],
    tooltip: {
      x: {
        formatter: (_, { dataPointIndex }) => formatCycleRange(rates[dataPointIndex]?.cycle),
      },
      y: {
        formatter: value => `${value.toFixed(1)}%`,
      },
    },
  }), [rates])

  const chartSeries = [{
    name: 'Connectivity Rate',
    data: rates.map(rate => Math.round(rate.conectivityRate * 100 * 10) / 10),
  }]

  return (
    <Chart
      options={chartOptions}
      series={chartSeries}
      type="area"
      height={300}
    />
  )
}

ConnectivityRatesChart.propTypes = {
  rates: PropTypes.arrayOf(
    PropTypes.shape({
      cycle: PropTypes.shape({
        id: PropTypes.string.isRequired,
        startsAt: PropTypes.string.isRequired,
        endsAt: PropTypes.string.isRequired,
      }).isRequired,
      conectivityRate: PropTypes.number.isRequired,
    }),
  ).isRequired,
}
